import styled from 'styled-components';

export const Container = styled.div`
	min-width: 100vh 100vw; 
  max-width: 100%;
`;

export const InternalContainer = styled.div`
	padding: 10vh 15vw;
`;
